import React, { useEffect, useRef, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers';
import * as yup from "yup";
import dayjs from 'dayjs';
import {
    TextField,
    Button,
    Grid,
    Autocomplete,
} from "@mui/material";
import 'dayjs/locale/it';
import { useDispatch, useSelector } from "react-redux";
import {
    createViagio,
    fetchViaggio,
    singleTrasporti,
    updateTrasportoData
} from "../../../features/trasporti/trasportiThunk";
import { fetchGiacenze, updateGiacenzaData } from "../../../features/giacenze/giacenzeThunk";
import { fetchMezzi } from "../../../features/Mezzi/mezziThunk";
dayjs.locale('it');

const schema = yup.object().shape({
    dataInizio: yup.date().required("Data inizio è obbligatoria"),
    dataFine: yup.date().required("Data fine è obbligatoria"),
    oreViaggio: yup.string().required("Ore di viaggio è obbligatorio"),
    partenza: yup.string().required("Partenza da è obbligatoria"),
    destinazione: yup.string().required("Destinazione a è obbligatoria"),
    vendita: yup.string().required("Vendita è obbligatoria"),
    casse: yup.mixed().required("Casse è obbligatorio"),
    bottiglie: yup.string().required("Bottiglie è obbligatorio"),
   autista: yup.string().required("Autista è obbligatorio"),
     trattore: yup.mixed(),
     mezzo: yup.mixed(),
});
const options = ["Amministratore", "Collaboratore", "Operatore"];

const ViaggiForm = ({ cantine ,setCantine,singleData}) => {
    const dispatch = useDispatch();
    const [price, setPrice] = useState(0);
    const venditaData = useSelector((store) => store.trasporto.viaggio);
    const giacenzeData = useSelector((store) => store.giacenze.giacenze);
    const autistiData = useSelector((store) => store.trasporto.autisti); // Access the autisti data
    const trattoriData = useSelector((store) => store.trasporto.trattori); // Access the trattori data
  const mezzoData = useSelector((store) => store.mezzi.mezzi);
  
  const mezzo = mezzoData
  ?.filter(item => item?.tipo_mezzo === "Mezzo")
  .map(item => ({ id: item?.id, name: item?.name }));

const trattori = mezzoData
  ?.filter(item => item?.tipo_mezzo === "Trattori")
  .map(item => ({ id: item?.id, name: item?.name }));

    useEffect(() => {
        dispatch(fetchViaggio());
        dispatch(fetchGiacenze());
        dispatch(fetchMezzi()); // Fetch mezzi data
    },[])


    const {
        control,
        handleSubmit,
        setValue,
        reset,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(schema),
    });

    // Initial useEffect for resetting the form from singleData
    useEffect(() => {
        if (cantine) {
            const payload = {
                dataInizio: singleData?.date_start ? dayjs(singleData?.date_start).format("YYYY-MM-DD") : null,
                dataFine: singleData?.date_end ? dayjs(singleData?.date_end).format("YYYY-MM-DD") : null,
                oreViaggio: singleData?.ore_viaggio,
                partenza: singleData?.partenanza_da,
                destinazione: singleData?.destinazione_a,
                vendita: singleData?.tipo_viaggio,
                autista: singleData?.vettore,
                trattore: singleData?.trattore,
                mezzo: singleData?.mezzo,
            };

            setValue("vendita", singleData?.tipo_viaggio || null);
            setValue("dataInizio", singleData?.date_start ? dayjs(singleData?.date_start) : null);
            setValue("dataFine", singleData?.date_end ? dayjs(singleData?.date_end) : null);
            setValue("trattore", singleData?.trattore || null);
            setValue("mezzo", singleData?.mezzo || null); // Set trattore value
            setValue("mezzo", singleData?.mezzo || null); // Set mezzo value

            reset(payload);
        }
    }, [singleData, reset, setValue]);

    useEffect(() => {
        if (singleData?.giacenze_id && cantine) {
            const selectedCassa = giacenzeData.find(item => item.id === singleData.giacenze_id);
            if (selectedCassa) {
                setValue("casse", selectedCassa);
                setValue("formato", selectedCassa.formato || "");
                setValue("bottiglie", selectedCassa.um || "");
                setValue("price", selectedCassa.displonibile || "");
                setPrice(selectedCassa?.displonibile);
            }
        }
    }, [singleData, giacenzeData, setValue]);
const hasMounted = useRef(false);

useEffect(() => {
    if (singleData && cantine) {
        const selectedMezzo = mezzo?.find(item => item.id == singleData?.mezzo);
        const selectedTrattore = trattori?.find(item => item.id == singleData?.trattore);
        setValue("mezzo", selectedMezzo);
      setValue("trattore", selectedTrattore);
      hasMounted.current = true;
    }
}, [singleData, mezzo, trattori, setValue]);

    const onSubmit = async (data) => {
        const mezzi_id = localStorage.getItem("mezzi_id");

        const payload = {
            mezzi_id,
            date_start: data.dataInizio ? dayjs(data.dataInizio).format("YYYY-MM-DD") : null,
            date_end: data.dataFine ? dayjs(data.dataFine).format("YYYY-MM-DD") : null,
            ore_viaggio: data.oreViaggio,
            partenanza_da: data.partenza,
            destinazione_a: data.destinazione,
            tipo_viaggio: data.vendita,
            giacenze_id: data.casse?.id,
            displonibile: data?.price,
            vettore: data.autista,
            trattore: data.trattore?.id,
            mezzo: data.mezzo?.id,
        };

        const original = giacenzeData.find(item => item.id === data.casse?.id);
        const originalPrice = original?.displonibile;

        const trasportoChanged =
            payload?.date_start !== singleData?.date_start ||
            payload?.date_end !== singleData?.date_end ||
            payload?.partenanza_da !== singleData?.partenanza_da ||
            payload?.ore_viaggio !== singleData?.ore_viaggio ||
            payload?.destinazione_a !== singleData?.destinazione_a ||
            payload?.tipo_viaggio !== singleData?.tipo_viaggio ||
            payload?.giacenze_id !== singleData?.giacenze_id ||
            payload?.autista !== singleData?.autista ||  // Track autista changes
            payload?.trattore !== singleData?.trattore ||  // Track trattore changes
            payload?.mezzo !== singleData?.mezzo;  // Track mezzo changes

        const priceChanged = originalPrice !== data.price;

        if (cantine) {
            try {
                if (trasportoChanged) {
                    await dispatch(updateTrasportoData({ id: singleData?.id, data: payload })).unwrap();
                    dispatch(singleTrasporti(singleData.id));
                }

                if (priceChanged) {
                    await dispatch(updateGiacenzaData({ id: data.casse?.id, data: { displonibile: data.price } })).unwrap();
                }

                localStorage.removeItem("viaggiLogistica");
                setCantine(false);
            } catch (err) {
                console.error("Update Error:", err);
            }
        } else {
            try {
                await dispatch(createViagio(payload)).unwrap();

                if (priceChanged) {
                    await dispatch(updateGiacenzaData({ id: data.casse?.id, data: { displonibile: data.price } })).unwrap();
                }

                setCantine(false);
            } catch (err) {
                console.error("Create Error:", err);
            }
        }
    };

    return (
        <form className="AziendaFrom" onSubmit={handleSubmit(onSubmit)}>
            <div className="AziendaFrom__inner">
            <label className="formLabel">Mezzi</label>

                 {/* Autista Field */}
                   <Controller
                             name="autista"
                             control={control}
                             render={({ field }) => (
                               <TextField
                                 className="customTextBox"
                                 {...field}
                                 value={field.value || ""}
                                 label="Autista/vettore"
                                 fullWidth
                                 margin="normal"
                                 error={!!errors.autista}
                                 helperText={errors.autista?.message}
                               />
                             )}
                           />

                {/* Trattore Field */}
                <Controller
                    name="trattore"
                    control={control}
                    render={({ field }) => (
                        <Autocomplete
                            {...field}
                            options={trattori}
                            getOptionLabel={(option) => option.name || ""}
                            isOptionEqualToValue={(option, value) => option.id === value.id}
                            value={field.value || null}
                            onChange={(event, value) => field.onChange(value)}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Trattore"
                                    className="customTextBox autoCompleteTextBox"
                                    margin="normal"
                                    fullWidth
                                    error={!!errors.trattore}
                                    helperText={errors.trattore?.message}
                                />
                            )}
                        />
                    )}
                />

                {/* Mezzo Field */}
                <Controller
                    name="mezzo"
                    control={control}
                    render={({ field }) => (
                        <Autocomplete
                            {...field}
                            options={mezzo}
                            getOptionLabel={(option) => option.name || ""}
                            isOptionEqualToValue={(option, value) => option.id === value.id}
                            value={field.value || null}
                            onChange={(event, value) => field.onChange(value)}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Mezzo"
                                    className="customTextBox autoCompleteTextBox"
                                    margin="normal"
                                    fullWidth
                                    error={!!errors.mezzo}
                                    helperText={errors.mezzo?.message}
                                />
                            )}
                        />
                    )}
                />

                <label className="formLabel">Viaggio</label>
                <Grid container spacing={1}>
                    <Grid size={4}>
                        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="it">
                            <Controller
                                name="dataInizio"
                                control={control}
                                render={({ field }) => (
                                    <DatePicker
                                        label="Data inizio"
                                        className='datePickerField'
                                        value={field.value ? dayjs(field.value) : null}
                                        onChange={(newValue) => field.onChange(newValue)}
                                    />
                                )}
                            />
                        </LocalizationProvider>
                    </Grid>
                    <Grid size={4}>
                        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="it">
                            <Controller
                                name="dataFine"
                                control={control}
                                render={({ field }) => (
                                    <DatePicker
                                        label="Data Fine"
                                        className='datePickerField'
                                        value={field.value ? dayjs(field.value) : null}
                                        onChange={(newValue) => field.onChange(newValue)}
                                    />
                                )}
                            />
                        </LocalizationProvider>
                    </Grid>
                    <Grid size={4}>
                        <Controller
                            name="oreViaggio"
                            control={control}
                            render={({ field }) => (
                                <TextField
                                    className="customTextBox"
                                    {...field}
                                    value={field.value || ""}
                                    label="Ore Viaggio"
                                    fullWidth
                                    margin="normal"
                                    error={!!errors.oreViaggio}
                                    helperText={errors.oreViaggio?.message}
                                />
                            )}
                        />
                    </Grid>
                </Grid>

                <Controller
                    name="partenza"
                    control={control}
                    render={({ field }) => (
                        <TextField
                            className="customTextBox"
                            {...field}
                            value={field.value || ""}
                            label="Partenza da"
                            fullWidth
                            margin="normal"
                            error={!!errors.partenza}
                            helperText={errors.partenza?.message}
                        />
                    )}
                />
                <Controller
                    name="destinazione"
                    control={control}
                    render={({ field }) => (
                        <TextField
                            className="customTextBox"
                            {...field}
                            value={field.value || ""}
                            label="Destinazione a"
                            fullWidth
                            margin="normal"
                            error={!!errors.destinazione}
                            helperText={errors.destinazione?.message}
                        />
                    )}
                />

                <label className="formLabel">Trasporto</label>
                <Controller
                    name="vendita"
                    control={control}
                    render={({ field }) => (
                        <Autocomplete
                            {...field}
                            options={venditaData}
                            value={field.value || null}
                            onChange={(event, value) => setValue("vendita", value)}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Vendita"
                                    className="customTextBox autoCompleteTextBox"
                                    margin="normal"
                                    fullWidth
                                    error={!!errors.vendita}
                                    helperText={errors.vendita?.message}
                                />
                            )}
                        />
                    )}
                />

               
                <Controller
                    name="casse"
                    control={control}
                    render={({ field }) => (
                        <Autocomplete
                            {...field}
                            options={giacenzeData}
                            getOptionLabel={(option) => option.name || ""}
                            isOptionEqualToValue={(option, value) => option.id === value.id}
                            value={field.value || null}
                            onChange={(event, value) => {
                                field.onChange(value);
                                if (value) {
                                    setValue("formato", value.formato || "");
                                    setValue("bottiglie", value.um || "");
                                    setValue("price", value.displonibile || "");
                                    setPrice(value.displonibile);
                                }
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Chianti classico 2019"
                                    className="customTextBox autoCompleteTextBox"
                                    margin="normal"
                                    fullWidth
                                    error={!!errors.casse}
                                    helperText={errors.casse?.message}
                                />
                            )}
                        />
                    )}
                />

                <Grid container spacing={1}>
                    <Grid size={5}>
                        <Controller
                            name="formato"
                            control={control}
                            render={({ field }) => (
                                <TextField
                                    className="customTextBox"
                                    {...field}
                                    label="Formato"
                                    value={field.value || ""}
                                    fullWidth
                                    margin="normal"
                                    error={!!errors.formato}
                                    helperText={errors.formato?.message}
                                    disabled
                                />
                            )}
                        />
                    </Grid>
                    <Grid size={5}>
                        <Controller
                            name="bottiglie"
                            control={control}
                            render={({ field }) => (
                                <TextField
                                    className="customTextBox"
                                    {...field}
                                    value={field.value || ""}
                                    label="Bottiglie (UM)"
                                    fullWidth
                                    margin="normal"
                                    error={!!errors.bottiglie}
                                    helperText={errors.bottiglie?.message}
                                    disabled
                                />
                            )}
                        />
                    </Grid>
                    <Grid size={2}>
                        <Controller
                            name="price"
                            control={control}
                            render={({ field }) => (
                                <TextField
                                    className="customTextBox"
                                    {...field}
                                    value={field.value || ""}
                                    label="120"
                                    fullWidth
                                    margin="normal"
                                    error={!!errors.price}
                                    helperText={errors.price?.message}
                                />
                            )}
                        />
                    </Grid>
                </Grid>

                <label
                    style={{
                        display: "block",
                        marginTop: "1%",
                        marginBottom: "10%",
                        fontWeight: "400",
                        fontSize: "10px",
                        lineHeight: "100%",
                        textAlign: "right"
                    }}
                >
                    Q.ta dis.: {price}
                </label>
                <div className="btnPart1">
                    <Button type="submit" variant="contained">
                        Salva dati
                    </Button>
                </div>
            </div>
        </form>
    );
};

export default ViaggiForm;
